module.exports = __webpack_public_path__ + "affd60329a07bb709b3d0b712e5407ae.pdf";